import { useEffect, useState } from "react";

import { ValidateInput } from "../../utilities"

function CustomizedTextInput(props) {
    const {
        label,
        name,
        required,
        value,
        error,
        schema
    } = props

    const [isValid, setIsValid] = useState(!error)

    const validateInput = (e) => {
        const valid = ValidateInput(schema, { [name]: e.target.value })
        setIsValid(valid)
    }

    const onFocus = event => {
        if (event.target.autocomplete) {
            event.target.autocomplete = "whatever";
        }

    };

    useEffect(() => {
        setIsValid(!error)
    }, [error])

    return <div className={`form-group form-element ${!isValid ? "error" : ""}`}>
        <label htmlFor={name}>{label} {required ? <span className='text-danger'>*</span> : null}</label>
        <input 
            type="text" 
            autoComplete="off" 
            className="form-control" 
            name={name} 
            id={name} 
            placeholder={label} 
            defaultValue={value ?? ''}
            onFocus={onFocus} 
            onChange={validateInput} 
        />
    </div>
}

export default CustomizedTextInput;